module.exports = __webpack_public_path__ + "static/img/22g.9c6412a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22g.jpg
// module id = nqdz
// module chunks = 0